module.exports = __webpack_public_path__ + "static/img/3.5fe8ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/doublelift/3.png
// module id = yDS9
// module chunks = 35